import React, {useEffect, useRef, useState} from "react";
import {ReactTabulator} from "react-tabulator";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions";
import {
  calculateSumOfEachRow,
  deleteRowHandler, myCustomCelEditFunction, updateTableCellHandler,
} from "../SellFactorFunctions";
import tableCalc from "../../../utils/tableCalc";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {parseToEnRemoveComma} from "../../../utils/CommaSeparator";

const FactorTableJozNEW = ({
                             sendData,
                             setSendData,
                             initialData,
                             componentData,
                             setComponentData,
                           }) => {

  // const tableRef = useRef();
  const tableOptions = {
    layout: "fitDataStretch",
    selectable: 1,
    index: "na_31",
  };
  // recordId: "",
  //   productId: "1",
  //   productName: "productName",
  //   productGroup: "productGroup",
  //   productSize: "productSize",
  //   productColor: "productColor",
  //   price: 200,
  //   number: "number",
  //   discount: "discount",
  //   storeId: 2
  const tableColumns = [
    {
      title: "حذف",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        width: 200,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItem: 'center',
        justifyContent: 'center',
      },
      justifyContent: 'center',
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        console.log("حذف حذف حذف");
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const tableData = deleteRowHandler(
          sendData.tableData,
          productId,
          storeId
        );
        setSendData({tableData});
      },
    },
    {
      field: "recordId",
      visible: false,
    },
    {
      title: "کد انبار",
      field: "storeId",
      visible: false,
      style: {
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "نام انبار",
      field: "storeName",
      visible: true,
      style: {
        minWidth: 80,
        width: 80,
        maxWidth: 80,
        textAlign: 'center',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "کد کالا",
      field: "productId",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "نام کالا",
      field: "productName",
      style: {
        minWidth: 200,
        width: 200,
        maxWidth: 200,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "گروه کالا",
      field: "productGroup",
      visible: false,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "رنگ",
      field: "productColor",
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "سایز",
      field: "productSize",
      style: {
        minWidth: 50,
        width: 50,
        maxWidth: 50,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "تعداد",
      field: "number",
      editor: "number",
      formatter: tableCalc.separateNumbers,
      style: {
        minWidth: 50,
        width: 50,
        maxWidth: 50,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },


      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)
        // مقدار منحصر به فرد هر سطر داره بر اساس ترکیب انبار و کدمحصول گرفته میشه
        myCustomCelEditFunction(sendData, setSendData, cell, "number", value)
        setReload(!reload)


      },

      editorParams: {
        min: 1,
        step: 1,
      },

      bottomCalc: tableCalc.sum,
    },
    {
      title: "قیمت",
      field: "price",
      editor: "number",
      editorParams: {
        min: 1,
        step: 1,
      },
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      formatter: tableCalc.separateNumbers, // topCalc : tableCalc.sum,
      cellEdited: function (e, cell) {

        let value = parseToEnRemoveComma(e.target.value);
        if (value === '') {
          value = 0
        }

        myCustomCelEditFunction(sendData, setSendData, cell, "price", value);
        setReload(!reload)

      },
    },
    {
      title: "تخفیف",
      field: "discount",
      editor: "number",
      editorParams: {
        min: 0,
        step: 1,
      },
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      bottomCalc: tableCalc.sum,
      formatter: tableCalc.separateNumbers,
      cellEdited: function (e, cell) {
        if (initialData?.addDiscount){
          let value = parseToEnRemoveComma(e.target.value);
          if (value === '') {
            value = 0
          }
          myCustomCelEditFunction(sendData, setSendData, cell, "discount", value)
          setReload(!reload)
        }
      },
    },
    {
      title: "جمع کل",
      field: "total", // bottomCalc: "sum",
      bottomCalc: tableCalc.sum,
      hozAlign: "center", // minWidth: 250,
      style: {
        minWidth: 100,
        width: 100,
        maxWidth: 150,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  ];


  // دفعه توی حالت ادیت جدول آپدیت نمیشد مگه اینکه  اطلاعات سنددیتا تغییر میکرد. منم اینجا اینو گذاشتم تا کار کنه
  const [reload, setReload] = useState(false)


  useEffect(() => {
    setSendData({tableData: calculateSumOfEachRow(sendData.tableData)});

  }, [reload])

  return (
      <div>
        <NewTabulator
          columns={tableColumns}
          // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
          data={sendData.tableData}
          options={tableOptions}
          // options={TabulatorTableOptions.style3}
          style={{height: "40vh", overflowY: 'scroll'}}
          className={"header__color__F1F1F1"}
        />
      </div>
  );
};

export default FactorTableJozNEW;
